import { jsx as _jsx } from "react/jsx-runtime";
import { toast } from 'sonner';
import { useUpdateMemberRole } from '../../hooks/useProjects';
import { apiErrorMessage } from '../../lib/api/apiErrorMessage';
export function MemberRoleSelect({ projectId, member, currentRole }) {
    const updateMemberRole = useUpdateMemberRole();
    // Only allow member ↔ view_only changes (not owner)
    const availableRoles = [
        {
            value: 'member',
            label: 'Member'
        },
        {
            value: 'view_only',
            label: 'View Only'
        }
    ];
    const handleRoleChange = async (newRole)=>{
        if (newRole === currentRole) return;
        try {
            await updateMemberRole.mutateAsync({
                projectId,
                userId: member.userId,
                role: newRole
            });
            toast.success(`${member.name}'s role updated to ${newRole.replace('_', ' ')}`);
        } catch (error) {
            toast.error(apiErrorMessage(error, 'Failed to update member role'));
        }
    };
    // Don't show role selector for owner
    if (currentRole === 'owner') {
        return null;
    }
    return /*#__PURE__*/ _jsx("select", {
        value: currentRole,
        onChange: (e)=>handleRoleChange(e.target.value),
        disabled: updateMemberRole.isPending,
        className: "text-xs border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50",
        "aria-label": `Change ${member.name}'s role`,
        "data-testid": `role-select-${member.userId}`,
        children: availableRoles.map((role)=>/*#__PURE__*/ _jsx("option", {
                value: role.value,
                children: role.label
            }, role.value))
    });
}
